import LocaleResolver from "csi/config/LocaleResolver";
import AggregateInlineConstructor from "csi/heading/Aggregate";
import { hasAggregateStoreForAttribute } from "csi/reflection/reflection";
import { C8Node } from "csi/typings";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

// TODO: Try to flip this so that AggregateInline overrides the default rather than this overriding AggregateInline

const AggregateAttribute = declare(AggregateInlineConstructor, {
	m_id: "AggregateAttribute",
	m_tag: "AggregateAttribute",

	/**
	 * @override
	 * Return true if there is an aggregate store for the attribute or for Headings with a child Relationship
	 */
	checkNodeAccess(node: C8Node): boolean {
		// if view does not have root node, node can be null and is of course not editable
		if (!node) {
			return false;
		}

		const { heading: { m_id, m_relationship, _rca } } = this;
		const hasAggregateStore = hasAggregateStoreForAttribute(node.$Type, m_id);

		// perform normal checks if configured old way (with relationship), or normal aggregate store
		if (m_relationship || (hasAggregateStore && !_rca.isReverseRelation)) {
			return this.inherited<boolean>(arguments);
		}

		// if reverse aggregate store, then just check for rights on node if explicitly specified in action;
		// do not check the attribute flags as it is likely read-only for reverse relationships
		if (hasAggregateStore && _rca.isReverseRelation) {
			return xml.nodeHasRight(node, this.m_right);
		}

		return false;
	},

	/** 
	 * @override
	 * Return AggregateInline to stay consistent with old naming
	 */
	_getNameTag(lr: LocaleResolver): string {
		return "AggregateInline";
	},
});

export = AggregateAttribute;
